import { render, staticRenderFns } from "./AmModal.vue?vue&type=template&id=563ab8a1&"
import script from "./AmModal.vue?vue&type=script&lang=js&"
export * from "./AmModal.vue?vue&type=script&lang=js&"
import style0 from "./AmModal.vue?vue&type=style&index=0&id=563ab8a1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports